var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicatereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7895 2H5.68421C4.75789 2 4 2.81818 4 3.81818V16.5455H5.68421V3.81818H15.7895V2ZM18.3158 5.63636H9.05263C8.12632 5.63636 7.36842 6.45455 7.36842 7.45455V20.1818C7.36842 21.1818 8.12632 22 9.05263 22H18.3158C19.2421 22 20 21.1818 20 20.1818V7.45455C20 6.45455 19.2421 5.63636 18.3158 5.63636ZM18.3158 20.1818H9.05263V7.45455H18.3158V20.1818Z",
    fill: "currentColor"
  })));
}
export default SvgDuplicatereact;